
import DateComponent from '@/components/DateComponent.vue';
import DialogTableSubstr from '@/components/DialogTableSubstr.vue';
import { mainStore } from '@/store';
import { format } from 'date-fns';
import { Component, Vue } from 'vue-property-decorator';
import { retencaoFinanceiraStore } from '../../../utils/store-accessor';

@Component({
  components: { DialogTableSubstr, DateComponent },
})
export default class ListMessageSyngoo extends Vue {
  public isLoading = false;
  public companyItems = [];
  public propState = '';
  public dataFiltro = '';
  public mensagens_enviadas_syngoo = [];

  public c014ItemsPessoa = 0;

  public headerTitulos = [
    {
      text: 'Unidade',
      sortable: false,
      value: 'unidade',
      align: 'left',
    },
    {
      text: 'Franqueado',
      sortable: false,
      value: 'franqueado',
      align: 'left',
    },
    {
      text: 'Telefone',
      sortable: true,
      value: 'telefone',
      align: 'left',
    },
    {
      text: 'Mensagem',
      sortable: true,
      value: 'mensagem',
      align: 'left',
    },
    // {
    //   text: "Código de Barras",
    //   sortable: true,
    //   value: "codigo_barra",
    //   align: "left",
    // },
    {
      text: 'Documento',
      sortable: false,
      value: 'documento',
      align: 'left',
    },
    {
      text: 'Vencimento',
      sortable: false,
      value: 'data_vencimento',
      align: 'left',
    },
    {
      text: 'Valor Original',
      sortable: false,
      value: 'valor_original',
      align: 'left',
    },
    {
      text: 'Tipo Mensagem',
      sortable: true,
      value: 'tipo_aviso',
      align: 'left',
    },
    {
      text: 'Enviado em',
      sortable: false,
      value: 'created_at',
      align: 'left',
    },
    {
      text: 'Enviado por',
      sortable: false,
      value: 'created_by_name',
      align: 'left',
    },
  ];

  get allItemsUnidades() {
    let item = this.companyItems[1];
    return item;
  }

  get allItems() {
    let item = this.mensagens_enviadas_syngoo;

    if (this.c014ItemsPessoa > 0) {
      item = item.filter((f) => f.c014_id === this.c014ItemsPessoa);
    }

    if (this.dataFiltro) {
      item = item.filter(
        (f) => format(new Date(f.created_at), 'dd/MM/yyyy') === format(new Date(this.dataFiltro), 'dd/MM/yyyy')
      );
    }

    return item;
  }

  get currentUser() {
    return mainStore.userProfile;
  }

  public async mounted() {
    this.isLoading = true;

    await mainStore.userProfile;

    this.mensagens_enviadas_syngoo = await retencaoFinanceiraStore.listMessageSendSyngoo();

    this.isLoading = false;
  }
}
